// Contenidos en borrador de la Enciclopedia (2026-10-13).
//
// Un contenido nuevo que todavía no revisa Sebastián nace como BORRADOR: está en el
// código, con sus fuentes en la bibliografía central, pero no se muestra a nadie. El
// primero es la ficha de valoración en cuidados paliativos.
//
// Es la excepción deliberada a la regla de los kill-switch ON por defecto
// (`!== 'false'`), igual que la beta de describir heridas con IA: aquí lo seguro es que
// NO se vea hasta que alguien lo apruebe, así que se prende solo con `=== 'true'`.
// REACT_APP_ENCICLOPEDIA_BORRADORES=true en un despliegue de vista previa deja revisar
// los borradores en la app real. Publicar una ficha NO es prender esta variable en
// producción: es cambiar su estado aquí, en un PR.
//
// Este archivo es una hoja liviana a propósito: App lo importa para decidir el ítem del
// buscador, y si la decisión viviera junto a la ficha, el texto de la ficha y sus 51
// obras viajarían en la descarga inicial de todo visitante (revisión del 13-oct-2026).
export function borradoresVisibles() {
  return process.env.REACT_APP_ENCICLOPEDIA_BORRADORES === 'true';
}

// Estado de la ficha de valoración en cuidados paliativos. Fuente ÚNICA: de aquí lo
// leen la ficha (data/referencia/paliativosValoracion.js) y su contenido en la
// bibliografía central (`borrador` en data/bibliografiaPaliativos.js), así no pueden
// quedar uno publicado y el otro en borrador.
// Publicada el 2026-10-14: Sebastián la revisó y la aprobó ("dale, está bien"), con
// las frases en imperativo pasadas a un tono más cercano.
export const ESTADO_FICHA_PALIATIVOS = 'publicada';

// ¿Se muestra? Publicada, sí. En borrador, solo en una vista previa.
export function fichaPaliativosVisible() {
  return ESTADO_FICHA_PALIATIVOS !== 'borrador' || borradoresVisibles();
}

// El ítem del buscador global (App.jsx), o null si la ficha no se ve. App le pone el
// ícono y la acción: la decisión de mostrarlo vive aquí, con su prueba.
export function itemBuscadorPaliativos() {
  if (!fichaPaliativosVisible()) return null;
  return {
    id: 'nav-ref-paliativos',
    group: 'Secciones',
    label: 'Cuidados paliativos',
    sub: ESTADO_FICHA_PALIATIVOS === 'borrador' ? 'Valoración del adulto con cáncer avanzado (borrador)' : 'Valoración del adulto con cáncer avanzado',
    keywords: ['paliativos', 'paliativo', 'dolor total', 'cancer avanzado', 'fin de vida', 'esas', 'painad', 'distres', 'desmoralizacion', 'espiritual', 'zarit', 'cuidador', 'conspiracion del silencio', 'voluntad anticipada', 'necpal', 'idc-pal'],
    seccion: 'paliativos',
  };
}

// Estado de la ficha de accesos vasculares (2026-10-16), con la misma regla: fuente
// ÚNICA para la ficha (data/referencia/accesosVasculares.js) y su contenido en la
// bibliografía central (data/bibliografiaAccesosVasculares.js). Nació borrador para el
// curso de FENEECh.
// Publicada el 2026-10-16: Sebastián la mandó a producción ("tíralas porfa a producción")
// después de la revisión clínica, la auditoría externa con GPT y la comprobación de
// esas correcciones en los documentos originales.
export const ESTADO_FICHA_ACCESOS = 'publicada';

export function fichaAccesosVisible() {
  return ESTADO_FICHA_ACCESOS !== 'borrador' || borradoresVisibles();
}

export function itemBuscadorAccesos() {
  if (!fichaAccesosVisible()) return null;
  return {
    id: 'nav-ref-accesos-vasculares',
    group: 'Secciones',
    label: 'Accesos vasculares',
    sub: ESTADO_FICHA_ACCESOS === 'borrador' ? 'Cuidado y valoración en la persona adulta (borrador)' : 'Cuidado y valoración en la persona adulta',
    keywords: ['accesos vasculares', 'acceso vascular', 'via venosa periferica', 'vvp', 'cateter', 'flebitis', 'infiltracion', 'extravasacion', 'escala vip', 'recambio de via', 'cvc', 'cateter venoso central', 'picc', 'linea media', 'midline', 'reservorio', 'linea arterial', 'test de allen', 'embolia gaseosa', 'a-diva'],
    seccion: 'accesos-vasculares',
  };
}
